import { Tooltip as ArkTooltip } from '@ark-ui/react/tooltip';
import { css } from '@styled-system/css';
import type { ReactNode } from 'react';

interface TooltipProps {
  label: ReactNode;
  children: ReactNode;
  placement?:
    | 'top'
    | 'top-start'
    | 'top-end'
    | 'bottom'
    | 'bottom-start'
    | 'bottom-end'
    | 'left'
    | 'left-start'
    | 'left-end'
    | 'right'
    | 'right-start'
    | 'right-end';
  openDelay?: number;
  closeDelay?: number;
  /** Texte long : retour à la ligne, largeur bornée (sinon une seule ligne). */
  multiline?: boolean;
}

const surfaceStyles = css.raw({
  bg: 'surface.elevated',
  color: 'text.primary',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderColor: 'border.default',
  borderRadius: 'md',
  boxShadow: 'md',
  px: '5',
  py: '3',
  fontFamily: 'sans',
  fontSize: 'caption',
  fontWeight: 'medium',
  whiteSpace: 'nowrap',
  zIndex: 1400,
  pointerEvents: 'none',
});

const surface = css(surfaceStyles);
// Fusion au niveau des styles (et non deux classes atomiques concurrentes) : `whiteSpace` remplacé
const multilineSurface = css(surfaceStyles, { whiteSpace: 'normal', maxWidth: '280px' });

export const Tooltip = ({
  label,
  children,
  placement = 'top',
  openDelay = 250,
  closeDelay = 100,
  multiline = false,
}: TooltipProps) => (
  <ArkTooltip.Root positioning={{ placement }} openDelay={openDelay} closeDelay={closeDelay}>
    <ArkTooltip.Trigger asChild>{children}</ArkTooltip.Trigger>
    <ArkTooltip.Positioner>
      <ArkTooltip.Content className={multiline ? multilineSurface : surface}>{label}</ArkTooltip.Content>
    </ArkTooltip.Positioner>
  </ArkTooltip.Root>
);
